// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1JBHF","productName":"Table_productName__1Gl3k"};